import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import MuiListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
  createTheme,
  makeStyles,
  ThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import React, { useContext, useState } from "react";
import { NavLink as NavLinkRRD } from "react-router-dom";
import { NavLink } from "reactstrap";
import kavidaLogoSideBar from "../../assets/images/kavidaLogoSideBar.png";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import { getProgress, updateUserJourneyState } from "./mockUtils";

const drawerWidth = 240;

export default function MockSideBarComponent({ routeTemplates }) {
  const [routes, setRoutes] = useState(routeTemplates);
  const [selectedIndex, setSelectedIndex] = useState("");
  const userContext = useContext(userJourneyContext);

  const makeApiCall = () => {
    (async () => {
      try {
        userContext.setUserJourneyInfo(
          updateUserJourneyState(userContext.userJourneyInfo)
        );
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyProgress)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  };

  const theme = createTheme({
    typography: {
      body1: {
        fontFamily: "Inter",
        fontSize: "15px",
      },
    },
  });

  const ListItem = withStyles({
    root: {
      "&$selected": {
        backgroundColor: "#3E4049",
        borderLeft: "4px solid #DDE2FF",
        color: "#A4A6B3",
        "& .MuiListItemIcon-root": {
          color: "#A4A6B3",
        },
      },
      "&$selected:hover": {
        backgroundColor: "#3E4049",
        color: "#A4A6B3",
        "& .MuiListItemIcon-root": {
          color: "#A4A6B3",
        },
      },
      "&:hover": {
        backgroundColor: "#3E4049",
        color: "#A4A6B3",
        "& .MuiListItemIcon-root": {
          color: "#A4A6B3",
        },
      },
    },
    selected: {},
  })(MuiListItem);

  const handleListItemClick = (event, name) => {
    setSelectedIndex(name);
    if (name === "Global Risks") {
      makeApiCall();
    }
  };

  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <CssBaseline />
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <div className={classes.toolbar} />
          <div
            style={{
              display: "flex",
              paddingBottom: "5%",
              cursor: "pointer",
              paddingLeft: "16px",
            }}
          >
            <img
              src={kavidaLogoSideBar}
              style={{
                width: "156px",
                height: "52px",
                marginLeft: "16px",
              }}
              alt={"KAVIDA"}
              loading="lazy"
            />
          </div>
          <Divider />{" "}
          {routes &&
            routes.length > 0 &&
            routes.map((prop, key) => {
              return (
                <List key={key}>
                  {userContext.userJourneyInfo.payload.steps === 18 ? 
                  <NavLink
                  className={`${classes.list} ${prop.component}`}
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 300,
                    textDecoration: "none",
                    color: "#A4A6B3",
                    fontSize: "12px",
                    display: "flex",
                    flexDirection: "row",
                    padding: "2px",
                  }}
                  to={prop.layout + prop.path}
                  tag={NavLinkRRD}
                >
                  <ListItem
                    button
                    key={prop.name}
                    selected={selectedIndex === prop.name}
                    onClick={(event) => handleListItemClick(event, prop.name)}
                  >
                    <ListItemIcon>
                      <i
                        style={{
                          color: "#9FA2B4",
                          fontSize: "18px",
                          // paddingTop: "5px",
                          marginLeft: "10px",
                        }}
                        className={prop.icon}
                      />
                    </ListItemIcon>
                    <ListItemText primary={prop.name} />
                  </ListItem>
                </NavLink>
                : 
                <NavLink
                    className={`${classes.list} ${prop.component}`}
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 300,
                      textDecoration: "none",
                      color: "#A4A6B3",
                      fontSize: "12px",
                      display: "flex",
                      flexDirection: "row",
                      padding: "2px",
                    }}
                    // to={prop.layout + prop.path}
                    // tag={NavLinkRRD}
                  >
                    <ListItem
                      button
                      key={prop.name}
                      // selected={selectedIndex === prop.name}
                      onClick={(event) => handleListItemClick(event, prop.name)}
                    >
                      <ListItemIcon>
                        <i
                          style={{
                            color: "#9FA2B4",
                            fontSize: "18px",
                            // paddingTop: "5px",
                            marginLeft: "10px",
                          }}
                          className={prop.icon}
                        />
                      </ListItemIcon>
                      <ListItemText primary={prop.name} />
                    </ListItem>
                  </NavLink>}
                </List>
              );
            })}
        </Drawer>
      </div>
    </ThemeProvider>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  list: {
    "&:hover": {
      color: "#d9d9d9",
      cursor: "pointer",
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    background: "#0F172A",
    color: "#FFFFFF",
  },
  toolbar: {
    padding: "8px",
  },
}));
